import { render, staticRenderFns } from "./BorderBgCss.vue?vue&type=template&id=50a664a2&"
import script from "./BorderBgCss.vue?vue&type=script&lang=ts&"
export * from "./BorderBgCss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports